<template lang="pug">
#cover-art.has-text-centered
  croppa(
    v-model="artwork"
    remove-button-color="#3273dc"
    :width="width"
    :height="height"
    :prevent-white-space="true"
    :show-remove-button="true"
    :initial-image="defaultImage"
    @file-choose="choose"
    @image-remove="remove"
  )
  p(v-if="caption")
    b-icon(icon="magnify")
    span Scroll to zoom
</template>

<script>

export default {
  name: 'cover-art-tab',
  data() {
    return {
      artwork: {},
    };
  },
  methods: {
    choose() {
      this.$emit('input', this.artwork);
    },
    remove() {
      this.$emit('input', null);
    },
  },
  props: {
    caption: {
      type: Boolean,
      default: true,
    },
    defaultImage: {
      type: String,
      default: null,
    },
    height: {
      type: Number,
      default: 293,
    },
    radius: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 520,
    },
  },
  watch: {
    defaultImage() {
      this.artwork.refresh();
    },
  },
};
</script>

<style lang="scss">
#cover-art {
  p {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/episode/CoverArtTab.vue